import { lightPalette } from '@theme/light'

// TODO: inject theme name
export default () => ({ light: lightPalette })['light']
